module.exports = __webpack_public_path__ + "static/media/ca.b87a932d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ca.svg
// module id = 2058
// module chunks = 0